import { useAuth } from '../contexts/AuthContext'

/** Owners manage products and triage ideas; everyone but viewers can submit ideas. */
export function useProductRoles() {
  const { user } = useAuth()
  const names = user?.roles?.map((r) => r.name) ?? []
  const canEdit = Boolean(user?.is_superuser || names.includes('Organization Owner'))
  const isViewer = !user?.is_superuser && names.length > 0 && names.every((n) => n === 'Organization Viewer')
  return { canEdit, canSubmit: !isViewer }
}
